import React from 'react';

export const ComunicacionConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth : ['rh', 'rh_not_signer', 'admin'],
    routes  : [
        {
            path     : '/comunicacion',
            component: React.lazy(() => import('./Comunicacion'))
        }
    ]
};